import type { RefObject } from 'react';
import { useEffect, useCallback, useState } from 'react';

export const usePlaybackSettings = (
  videoRef: RefObject<HTMLVideoElement>,
  initialPlaybackRate: number,
) => {
  const [playbackRate, _setPlaybackRate] = useState(initialPlaybackRate);

  const setPlaybackRate = useCallback(
    (newPlaybackRate: number) => {
      if (videoRef.current) {
        videoRef.current.playbackRate = newPlaybackRate;
      }
    },
    [videoRef],
  );

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) {
      return;
    }

    const handleRateChangeEvent = () => {
      _setPlaybackRate(videoElement.playbackRate);
    };

    videoElement.playbackRate = initialPlaybackRate;
    videoElement.addEventListener('ratechange', handleRateChangeEvent);

    return () => {
      videoElement.removeEventListener('ratechange', handleRateChangeEvent);
    };
  }, [videoRef, initialPlaybackRate]);

  return {
    playbackRate,
    setPlaybackRate,
  };
};
